// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".greeting-text[data-v-7d7f711c]{text-transform:capitalize}.tasks-todo-text[data-v-7d7f711c]{font-weight:700;font-size:1.2em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
